<template>
    <div id="ProgressHeader">
        <div class="container py-2">
            <progress-header-step
                class="d-inline-block"
                :label="$t('airport_transfers.components.progress_header.step1')"
                :is-completed="isSearchComplete"
                :is-clickable="true"
                :is-active="currentRoute === 'airport-transfers.index'"
                route="airport-transfers.index"
            />

            <br class="d-sm-block d-md-none" />

            <div class="d-inline-block">
                <font-awesome-icon icon="chevron-right" />
            </div>

            <progress-header-step
                class="d-inline-block"
                :label="$t('airport_transfers.components.progress_header.step2')"
                :is-completed="isDeparturesComplete"
                :is-clickable="isSearchComplete"
                :is-active="currentRoute === 'airport-transfers.departures'"
                route="airport-transfers.departures"
            />

            <br class="d-sm-block d-md-none" />

            <div class="d-inline-block">
                <font-awesome-icon icon="chevron-right" />
            </div>

            <progress-header-step
                class="d-inline-block"
                :label="$t('airport_transfers.components.progress_header.step3')"
                :is-completed="isReturnsComplete"
                :is-clickable="searchData !== null && searchData.with_return && isSearchComplete && isDeparturesComplete"
                :is-active="currentRoute === 'airport-transfers.returns'"
                route="airport-transfers.returns"
                v-if="searchData !== null && searchData.with_return"
            />

            <br class="d-sm-block d-md-none" v-if="searchData !== null && searchData.with_return" />

            <div class="d-inline-block" v-if="searchData !== null && searchData.with_return">
                <font-awesome-icon icon="chevron-right" />
            </div>

            <progress-header-step
                class="d-inline-block"
                :label="$t('airport_transfers.components.progress_header.step4')"
                :is-completed="isPassengersComplete"
                :is-clickable="isSearchComplete && isDeparturesComplete && (!searchData.with_return || isReturnsComplete)"
                :is-active="currentRoute === 'airport-transfers.passengers'"
                route="airport-transfers.passengers"
            />

            <br class="d-sm-block d-md-none" />

            <div class="d-inline-block">
                <font-awesome-icon icon="chevron-right" />
            </div>

            <progress-header-step
                class="d-inline-block"
                :label="$t('airport_transfers.components.progress_header.step5')"
                :is-completed="isOptionsComplete"
                :is-clickable="isSearchComplete && isDeparturesComplete && isPassengersComplete && (!searchData.with_return || isReturnsComplete)"
                :is-active="currentRoute === 'airport-transfers.options'"
                route="airport-transfers.options"
            />

            <br class="d-sm-block d-md-none" />

            <div class="d-inline-block">
                <font-awesome-icon icon="chevron-right" />
            </div>

            <progress-header-step
                class="d-inline-block"
                :label="$t('airport_transfers.components.progress_header.step6')"
                :is-completed="false"
                :is-clickable="isSearchComplete && isDeparturesComplete && isPassengersComplete && isOptionsComplete && (!searchData.with_return || isReturnsComplete)"
                :is-active="currentRoute === 'airport-transfers.summary'"
                route="airport-transfers.summary"
            />
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import ProgressHeaderStep from '@components/ProgressHeaderStep';

    export default {
        components: {
            ProgressHeaderStep,
        },

        data() {
            return {
                currentRoute: this.$router.currentRoute.name,
            };
        },

        computed: {
            ...mapGetters({
                isSearchComplete: 'airportTransfersSearch/getIsSearchComplete',
                isDeparturesComplete: 'airportTransfersSearch/getIsDeparturesComplete',
                isReturnsComplete: 'airportTransfersSearch/getIsReturnsComplete',
                isPassengersComplete: 'airportTransfersSearch/getIsPassengersComplete',
                isOptionsComplete: 'airportTransfersSearch/getIsOptionsComplete',
                searchData: 'airportTransfersSearch/getSearchParameters',
            }),
        },
    };
</script>
